<div
  class="flex border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex-col gap-5 w-full"
>
  <div class="flex gap-2 items-center">
    <ng-icon name="heroLightBulb" size="20" class="!block" />
    <h2 class="leading-6 font-semibold">
      {{ 'cockpit.dashboard.assistantCard.title' | transloco }}
    </h2>
  </div>
  <ui-alert>
    {{ 'cockpit.dashboard.assistantCard.description' | transloco }}
  </ui-alert>
</div>
